import classNames from 'classnames';
import { Dialog } from 'rc-ui-lib';
import type { DialogProps } from 'rc-ui-lib/lib/dialog/PropsType';
import { useEffect, useRef, useState } from 'react';
import style from './index.module.less';

export type CommonDialogProps = {
  content?: string | React.ReactNode;
  contentClsName?: string;
  showBottomCover?: boolean;
} & DialogProps;

function CommonDialog(props: CommonDialogProps) {
  const { content, contentClsName, showBottomCover, visible } = props;
  const [isSingleLine, setIsSingleLine] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // 只在 Dialog 可见时检查
    if (visible && contentRef.current) {
      const timer = setTimeout(() => {
        if (contentRef.current) {
          setIsSingleLine(!isOverTwoLines(contentRef.current as HTMLElement));
        }
      }, 0);

      return () => clearTimeout(timer);
    }
  }, [visible, content]);

  const isOverTwoLines = (element: HTMLElement) => {
    const range = document.createRange();
    range.selectNodeContents(element);
    const rects = range.getClientRects();
    return rects.length > 2;
  };

  return (
    <Dialog {...props}>
      <div
        ref={contentRef}
        className={classNames(style.content, contentClsName, {
          [style.single_line]: isSingleLine,
          [style.no_title]: !props.title,
          [style.no_content]: !content,
        })}
      >
        {content}
      </div>
      {showBottomCover ? <div className={style.bottom_cover} /> : undefined}
    </Dialog>
  );
}

export default CommonDialog;
